import React from 'react';
import {Card, CardContent, CardHeader, Tooltip, Typography} from '@mui/material';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import ApartmentIcon from '@mui/icons-material/Apartment';
import VerifiedIcon from '@mui/icons-material/Verified';
import {ApplicantParty} from "../api/types/Applicant";

interface PartyCardProps {
    party: ApplicantParty;
    onClick?: () => void;
    actionMenu?: React.ReactNode;
}

const PartyCard = ({party, onClick, actionMenu}: PartyCardProps) => {
    const icon = party.isDefault ? <HomeWorkIcon sx={{fontSize: 70}}/> : <ApartmentIcon sx={{fontSize: 70}}/>
    return (
            <Card
                    onClick={onClick}
                    sx={{
                        width: "100%",
                        height: "100%",
                        minHeight: 200,
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                        '&:hover': {
                            cursor: "pointer",
                            '& .MuiTypography-root': {textDecoration: "underline"}
                        }
                    }}
            >
                {actionMenu && (
                        <CardHeader
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }}
                                action={actionMenu}
                                sx={{p: 1, pb: 0}}
                        />
                )}

                <CardContent sx={{
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    padding: "16px",
                    flexGrow: 1,
                    pt: actionMenu ? 0 : 2
                }}>
                    {icon}

                    <Typography
                            variant="h5"
                            textAlign="center"
                            sx={{
                                textOverflow: "ellipsis",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 4,
                                overflow: "hidden",
                                display: "-webkit-box",
                                alignItems: "center",
                                gap: "5px",
                                mt: 1
                            }}
                    >
                        {party.name}
                        {party.isDefault && (
                                <Tooltip title="Default">
                                    <VerifiedIcon color="info" sx={{marginLeft: 1, verticalAlign: 'middle'}}/>
                                </Tooltip>
                        )}
                    </Typography>
                </CardContent>
            </Card>
    );
};

export default PartyCard;